// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Link = require("./link");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Modal = require("./modal");
var Theme = require("./theme");
var React = require("react");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Network = require("./network");
var Storage = require("./storage");
var FoodSeed = require("./foodSeed");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Fat_iconSvg = require("./assets/fat_icon.svg");
var Obst_iconSvg = require("./assets/obst_icon.svg");
var Carbs_iconSvg = require("./assets/carbs_icon.svg");
var Lunch_iconSvg = require("./assets/lunch_icon.svg");
var Snack_iconSvg = require("./assets/snack_icon.svg");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");
var Dinner_iconSvg = require("./assets/dinner_icon.svg");
var Proteine_iconSvg = require("./assets/proteine_icon.svg");
var Breakfast_iconSvg = require("./assets/breakfast_icon.svg");
var Vegetables_iconSvg = require("./assets/vegetables_icon.svg");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var contentContainer = Css.style(/* :: */[
      Css.boxSizing(/* borderBox */9307263),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.width(/* `percent */[
                  -119887163,
                  100.0
                ]),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.margin4(Css.px(18), Css.px(0), Css.px(6), Css.px(0)),
              /* :: */[
                Css.borderTopLeftRadius(Css.px(10)),
                /* :: */[
                  Css.borderTopRightRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderBottomRightRadius(Css.px(10)),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var selectHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(24)),
      /* :: */[
        Css.margin4(Css.px(10), Css.px(0), Css.px(2), Css.px(0)),
        /* [] */0
      ]
    ]);

var selectEl = Css.style(/* :: */[
      Css.fontSize(Css.px(24)),
      /* :: */[
        Css.margin4(Css.px(4), Css.px(0), Css.px(10), Css.px(0)),
        /* [] */0
      ]
    ]);

var foodHeader = Css.style(/* :: */[
      Css.color(/* `hex */[
            5194459,
            "FF328C"
          ]),
      /* :: */[
        Css.fontSize(Css.px(22)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.margin4(Css.px(2), Css.px(0), Css.px(2), Css.px(14)),
            /* [] */0
          ]
        ]
      ]
    ]);

var foodHeaderH1 = Css.style(/* :: */[
      Css.lineHeight(1.1),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
        /* [] */0
      ]
    ]);

var foodHeaderH3 = Css.style(/* :: */[
      Css.fontWeight(400),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(6), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var foodContent = Css.style(/* :: */[
      Css.color(/* `hex */[
            5194459,
            "00C9C8"
          ]),
      /* :: */[
        Css.fontSize(Css.px(22)),
        /* :: */[
          Css.margin4(Css.px(10), Css.px(0), Css.px(18), Css.px(20)),
          /* :: */[
            Css.alignSelf(/* flexStart */662439529),
            /* [] */0
          ]
        ]
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.justifyContent(/* spaceBetween */516682146),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxHeader = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.justifyContent(/* spaceBetween */516682146),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.background(/* `hex */[
                        5194459,
                        "FFFAFA"
                      ]),
                  /* :: */[
                    Css.borderBottom(Css.px(1), /* solid */12956715, /* `hex */[
                          5194459,
                          "FFEEEF"
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxLeftEl = Css.style(/* [] */0);

var horizonBoxEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(8)),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.marginTop(Css.px(5)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var contentElInnerFrame = Css.style(/* :: */[
      Css.justifyContent(Css.center),
      /* :: */[
        Css.width(Css.px(100)),
        /* :: */[
          Css.height(Css.px(100)),
          /* :: */[
            Css.border(Css.px(2), /* solid */12956715, Css.hex("FFEEEF")),
            /* :: */[
              Css.borderRadius(Css.px(10)),
              /* :: */[
                Css.margin4(Css.px(34), Css.px(4), Css.px(4), Css.px(4)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var centerIcon = Css.style(/* :: */[
      Css.margin2(Css.px(2), Css.px(6)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.0,
                1.0
              ]
            ]),
        /* :: */[
          Css.padding4(Css.px(2), Css.px(2), Css.px(2), Css.px(2)),
          /* [] */0
        ]
      ]
    ]);

var smallIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.0,
                1.0
              ]
            ]),
        /* :: */[
          Css.padding4(Css.px(0), Css.px(2), Css.px(0), Css.px(12)),
          /* [] */0
        ]
      ]
    ]);

function smallerRedSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(100)),
              /* :: */[
                Css.maxWidth(Css.px(140)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(35)),
                    /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "FF328C"
                          ]),
                      /* :: */[
                        Css.margin4(Css.px(10), Css.px(8), Css.px(10), Css.px(0)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "FF328C"
                              ]),
                          Theme.redButtonNarrowRaw
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* contentContainer */contentContainer,
  /* contentBox */contentBox,
  /* selectHeader */selectHeader,
  /* selectEl */selectEl,
  /* foodHeader */foodHeader,
  /* foodHeaderH1 */foodHeaderH1,
  /* foodHeaderH3 */foodHeaderH3,
  /* foodContent */foodContent,
  /* horizonBox */horizonBox,
  /* horizonBoxHeader */horizonBoxHeader,
  /* horizonBoxLeftEl */horizonBoxLeftEl,
  /* horizonBoxEl */horizonBoxEl,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* contentElInnerFrame */contentElInnerFrame,
  /* centerIcon */centerIcon,
  /* smallIcon */smallIcon,
  /* smallerRedSecondaryButton */smallerRedSecondaryButton
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in food router");
      return 2;
    } else {
      throw exn;
    }
  }
}

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("FoodDayStage");

function make(day, stage, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var stageText;
      switch (stage) {
        case "breakfast" : 
            stageText = "Frühstück";
            break;
        case "dinner" : 
            stageText = "Abendessen";
            break;
        case "lunch" : 
            stageText = "Mittagessen";
            break;
        case "snack" : 
            stageText = "Snack";
            break;
        default:
          stageText = "no food";
      }
      var stageIcon;
      switch (stage) {
        case "breakfast" : 
            stageIcon = Breakfast_iconSvg;
            break;
        case "dinner" : 
            stageIcon = Dinner_iconSvg;
            break;
        case "lunch" : 
            stageIcon = Lunch_iconSvg;
            break;
        case "snack" : 
            stageIcon = Snack_iconSvg;
            break;
        default:
          stageIcon = Breakfast_iconSvg;
      }
      var match = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0) === "");
      var match$1 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0) !== "");
      var match$2 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1) === "");
      var match$3 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1) !== "");
      var match$4 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 2) === "");
      var match$5 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 2) !== "");
      var match$6 = +(stage !== "breakfast");
      var tmp;
      if (match$6 !== 0) {
        var match$7 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 3) === "");
        tmp = React.createElement("div", {
              className: horizonBoxHeader
            }, React.createElement("div", {
                  className: horizonBoxLeftEl
                }, React.createElement("img", {
                      className: smallIcon,
                      alt: "",
                      src: Vegetables_iconSvg
                    }), React.createElement("div", {
                      className: foodHeader
                    }, "Gemüse")), match$7 !== 0 ? React.createElement("button", {
                    className: smallerRedSecondaryButton(/* () */0),
                    onClick: (function () {
                        return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [4]));
                      })
                  }, "Auswählen") : React.createElement("button", {
                    className: smallerRedSecondaryButton(/* () */0),
                    onClick: (function () {
                        return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [4]));
                      })
                  }, "Ändern"));
      } else {
        tmp = null;
      }
      var match$8 = +(stage !== "breakfast");
      var tmp$1;
      if (match$8 !== 0) {
        var match$9 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 3) !== "");
        tmp$1 = match$9 !== 0 ? React.createElement("div", {
                className: foodContent
              }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 3)) : null;
      } else {
        tmp$1 = null;
      }
      var foodView = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: contentContainer
              }, React.createElement("div", {
                    className: contentBox
                  }, React.createElement("div", {
                        className: horizonBoxHeader
                      }, React.createElement("div", {
                            className: horizonBoxLeftEl
                          }, React.createElement("img", {
                                className: smallIcon,
                                alt: "Icon",
                                src: Carbs_iconSvg
                              }), React.createElement("div", {
                                className: foodHeader
                              }, "Carbs")), match !== 0 ? React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [1]));
                                })
                            }, "Auswählen") : React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [1]));
                                })
                            }, "Ändern")), match$1 !== 0 ? React.createElement("div", {
                          className: foodContent
                        }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0)) : null, React.createElement("div", {
                        className: horizonBoxHeader
                      }, React.createElement("div", {
                            className: horizonBoxLeftEl
                          }, React.createElement("img", {
                                className: smallIcon,
                                alt: "",
                                src: Proteine_iconSvg
                              }), React.createElement("div", {
                                className: foodHeader
                              }, "Proteine")), match$2 !== 0 ? React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [2]));
                                })
                            }, "Auswählen") : React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [2]));
                                })
                            }, "Ändern")), match$3 !== 0 ? React.createElement("div", {
                          className: foodContent
                        }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1)) : null, React.createElement("div", {
                        className: horizonBoxHeader
                      }, React.createElement("div", {
                            className: horizonBoxLeftEl
                          }, React.createElement("img", {
                                className: smallIcon,
                                alt: "",
                                src: Fat_iconSvg
                              }), React.createElement("div", {
                                className: foodHeader
                              }, "Fette")), match$4 !== 0 ? React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [3]));
                                })
                            }, "Auswählen") : React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [3]));
                                })
                            }, "Ändern")), match$5 !== 0 ? React.createElement("div", {
                          className: foodContent
                        }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 2)) : null, tmp, tmp$1)));
      var match$10 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1) === "");
      var match$11 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1) !== "");
      var match$12 = +(self[/* state */2][/* calsLevel */0] !== 2);
      var tmp$2;
      if (match$12 !== 0) {
        var match$13 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0) === "");
        tmp$2 = React.createElement("div", {
              className: horizonBoxHeader
            }, React.createElement("div", {
                  className: horizonBoxLeftEl
                }, React.createElement("img", {
                      className: smallIcon,
                      alt: "",
                      src: Obst_iconSvg
                    }), React.createElement("div", {
                      className: foodHeader
                    }, "Obst")), match$13 !== 0 ? React.createElement("button", {
                    className: smallerRedSecondaryButton(/* () */0),
                    onClick: (function () {
                        return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [6]));
                      })
                  }, "Auswählen") : React.createElement("button", {
                    className: smallerRedSecondaryButton(/* () */0),
                    onClick: (function () {
                        return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [6]));
                      })
                  }, "Ändern"));
      } else {
        tmp$2 = null;
      }
      var match$14 = +(self[/* state */2][/* calsLevel */0] !== 2);
      var tmp$3;
      if (match$14 !== 0) {
        var match$15 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0) !== "");
        tmp$3 = match$15 !== 0 ? React.createElement("div", {
                className: foodContent
              }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0)) : null;
      } else {
        tmp$3 = null;
      }
      var snackView = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: contentContainer
              }, React.createElement("div", {
                    className: contentBox
                  }, React.createElement("div", {
                        className: horizonBoxHeader
                      }, React.createElement("div", {
                            className: horizonBoxLeftEl
                          }, React.createElement("img", {
                                className: smallIcon,
                                alt: "",
                                src: Proteine_iconSvg
                              }), React.createElement("div", {
                                className: foodHeader
                              }, "Proteine")), match$10 !== 0 ? React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [5]));
                                })
                            }, "Auswählen") : React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [5]));
                                })
                            }, "Ändern")), match$11 !== 0 ? React.createElement("div", {
                          className: foodContent
                        }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1)) : null, tmp$2, tmp$3)));
      var match$16 = self[/* state */2][/* openModal */2];
      var match$17 = +(stage === "snack");
      return React.createElement("div", {
                  className: dashboard
                }, match$16 !== 0 ? ReasonReact.element(/* None */0, /* None */0, Modal.make(self[/* state */2][/* calsLevel */0], self[/* state */2][/* foodTypeName */4], self[/* state */2][/* foodTypeList */5], stageText, (function () {
                              return Curry._1(self[/* send */4], /* CloseModal */0);
                            }), (function (data) {
                              return Curry._1(self[/* send */4], /* SaveFood */Block.__(0, [data]));
                            }), /* array */[])) : null, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: contentElInnerFrame
                        }, React.createElement("img", {
                              className: centerIcon,
                              alt: "Icon",
                              src: stageIcon
                            })), React.createElement("h1", {
                          className: foodHeaderH1
                        }, stageText), React.createElement("h3", {
                          className: foodHeaderH3
                        }, "Tag " + day), match$17 !== 0 ? snackView : foodView, React.createElement("button", {
                          className: Theme.slimButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/foodday/" + day);
                            })
                        }, "Zurück"), ReasonReact.element(/* None */0, /* None */0, Link.make("/dashboard", "Dashboard", someLink, /* array */[]))));
    });
  newrecord[/* initialState */10] = (function () {
      var stageFood = Network.getStageFood(Caml_format.caml_int_of_string(day), stage);
      return /* record */[
              /* calsLevel */Storage.getCalsLevel(/* () */0),
              /* stageFood */stageFood,
              /* openModal : false */0,
              /* foodType */1,
              /* foodTypeName */"Carbs",
              /* foodTypeList */FoodSeed.carbs
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        var newrecord = state.slice();
        return /* Update */Block.__(0, [(newrecord[/* openModal */2] = /* false */0, newrecord)]);
      } else if (action.tag) {
        var foodType = action[0];
        var switcher = foodType - 1 | 0;
        var foodTypeName;
        if (switcher > 5 || switcher < 0) {
          foodTypeName = "Gemüse";
        } else {
          switch (switcher) {
            case 0 : 
                foodTypeName = "Carbs";
                break;
            case 2 : 
                foodTypeName = "Fette";
                break;
            case 3 : 
                foodTypeName = "Gemüse";
                break;
            case 1 : 
            case 4 : 
                foodTypeName = "Proteine";
                break;
            case 5 : 
                foodTypeName = "Obst";
                break;
            
          }
        }
        var switcher$1 = foodType - 1 | 0;
        var foodTypeList;
        if (switcher$1 > 5 || switcher$1 < 0) {
          foodTypeList = FoodSeed.veggies;
        } else {
          switch (switcher$1) {
            case 0 : 
                foodTypeList = FoodSeed.carbs;
                break;
            case 1 : 
                foodTypeList = FoodSeed.protein;
                break;
            case 2 : 
                foodTypeList = FoodSeed.fat;
                break;
            case 3 : 
                foodTypeList = FoodSeed.veggies;
                break;
            case 4 : 
                foodTypeList = FoodSeed.snacks;
                break;
            case 5 : 
                foodTypeList = FoodSeed.fruits;
                break;
            
          }
        }
        return /* Update */Block.__(0, [/* record */[
                    /* calsLevel */state[/* calsLevel */0],
                    /* stageFood */state[/* stageFood */1],
                    /* openModal : true */1,
                    /* foodType */foodType,
                    /* foodTypeName */foodTypeName,
                    /* foodTypeList */foodTypeList
                  ]]);
      } else {
        var selectedFood = action[0];
        var stageFoodUpdate = state[/* stageFood */1];
        var match = +(state[/* foodType */3] === 5);
        var foodTypeSave;
        if (match !== 0) {
          foodTypeSave = 2;
        } else {
          var match$1 = +(state[/* foodType */3] === 6);
          foodTypeSave = match$1 !== 0 ? 1 : state[/* foodType */3];
        }
        Caml_array.caml_array_set(stageFoodUpdate, foodTypeSave - 1 | 0, selectedFood);
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[
                    /* calsLevel */state[/* calsLevel */0],
                    /* stageFood */stageFoodUpdate,
                    /* openModal : false */0,
                    /* foodType */state[/* foodType */3],
                    /* foodTypeName */state[/* foodTypeName */4],
                    /* foodTypeList */state[/* foodTypeList */5]
                  ],
                  (function () {
                      Network.writeFoodToLs(convToInt(day), stage, foodTypeSave, selectedFood);
                      return /* () */0;
                    })
                ]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/foodDayStage.re
// module id = 149
// module chunks = 0